import React from "react";
import styles from "./details.module.css";
import { Col, Divider, Row, Typography } from "antd";
import SVGIcon from "../../../../../../constants/SVGIcon";
import { formatDate } from "../../../../../../utils/format-date/format-date";

const Details = ({ details }) => {
  const contactDetails = details?.contact_details
    ? details?.contact_details
    : null;
  const medicalDetails = details?.medical_details
    ? details?.medical_details
    : null;
  const academicDetails = details?.academic_details
    ? details?.academic_details
    : null;
  const signature = details?.metadata ?? {};
  const bankInfo = details?.bank_details?.length
    ? details?.bank_details?.[0]
    : {};

  const handleDownload = (imageUrl) => {
    const fileName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);

    const link = document.createElement("a");
    link.href = imageUrl; // Use the pre-signed URL (S3 URL)
    link.download = fileName; // Set the filename based on the URL
    link.setAttribute("target", "_self");
    link.setAttribute("rel", "noopener noreferrer");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up by removing the link
  };

  const studentFields = [
    {
      groupName: "Personal Information",
      groupFields: [
        { label: "Full Name", value: details?.name },
        { label: "Nationality", value: details?.nationality },
        { label: "Gender", value: details?.gender },
        { label: "Nation ID number", value: details?.national_id_number },
        { 
          label: "Date of Birth", 
          value: details?.date_of_birth ? formatDate(details?.date_of_birth) : "-"
        },
      ]
    },
    {
      groupName: "Contact Information",
      groupFields: [
        { label: "Address", value: contactDetails?.address },
        { label: "City", value: contactDetails?.city },
        { label: "Province", value: contactDetails?.province },
        { label: "Country", value: contactDetails?.country },
        { label: "Email", value: contactDetails?.email },
        { label: "Phone no", value: contactDetails?.phone },
        { label: "Emg contact person", value: contactDetails?.emergency_contact_person },
        { label: "Emergency contact", value: contactDetails?.emergency_contact_number },
      ]
    },
    {
      groupName: "Bank Information",
      groupFields: [
        { label: "Account Holder Name", value: bankInfo?.account_holder_name },
        { label: "Account Number", value: bankInfo?.bank_account_number },
        { label: "Bank Name", value: bankInfo?.bank_name },
        { label: "Branch Code", value: bankInfo?.branch_code },
      ]
    },
    {
      groupName: "Medical Information",
      groupFields: [
        { label: "Have Allergy", value: medicalDetails?.allergies },
        { label: "Special Needs", value: medicalDetails?.special_needs },
      ]
    },
    {
      groupName: "Documents",
      groupFields: [
        { label: "Signature", value: signature?.signature },
        { label: "Signature Date", value: signature?.date },
      ]
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        {studentFields?.map((item, index) => (
          <div key={index} style={{ width: "100%" }}>
            <Divider
              orientation="left"
              orientationMargin="0"
              style={{ margin: "0 0 12px 0" }}
            >
              <Typography className={styles.dividerTitle}>
                {item?.groupName}
              </Typography>
            </Divider>
            <Row gutter={[0, 10]}>
              {item?.groupFields?.map((field, fieldIndex) => (
                <Col md={24} lg={12}>
                  <div key={fieldIndex} className={styles.informationContainer}>
                    <Typography className={styles.infoLabelClass}>{field?.label}:</Typography>
                    <div className={styles.valueWrapper}>
                      <Typography className={styles.infoValueClass}>
                        {field?.value || "-"}
                      </Typography>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ))}

        <div className={styles.fileInfoContainer}>
          {details?.birth_certificate ? (
            <div
              className={styles.fileCardContainer}
              onClick={() => handleDownload(details?.birth_certificate)}
            >
              <Typography>birth-certificate</Typography>
              <SVGIcon
                name={"download-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#344054"}
              />
            </div>
          ) : (
            <></>
          )}
          {academicDetails?.transfer_certificate ? (
            <div
              className={styles.fileCardContainer}
              onClick={() =>
                handleDownload(academicDetails?.transfer_certificate)
              }
            >
              <Typography>transfer-certificate</Typography>
              <SVGIcon
                name={"download-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#344054"}
              />
            </div>
          ) : (
            <></>
          )}
          {academicDetails?.report_card ? (
            <div
              className={styles.fileCardContainer}
              onClick={() => handleDownload(academicDetails?.report_card)}
            >
              <Typography>report-card</Typography>
              <SVGIcon
                name={"download-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#344054"}
              />
            </div>
          ) : (
            <></>
          )}
          {medicalDetails?.medical_certificate ? (
            <div
              className={styles.fileCardContainer}
              onClick={() =>
                handleDownload(medicalDetails?.medical_certificate)
              }
            >
              <Typography>medical-certificate</Typography>
              <SVGIcon
                name={"download-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#344054"}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Details;
